<div class="page-container">
    <div class="header-section">
        <lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>
        <h2 class="page-title">Role Menu Mapping</h2>
    </div>

    <!-- Search Criteria Panel -->
    <div class="content-wrapper">
        <form [formGroup]="searchForm" (ngSubmit)="onSearch()" class="search-form-card">
            <div class="search-grid">
                <div class="form-item">
                    <mat-label class="required-label">Role ID</mat-label>
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-select formControlName="newRoleId" (selectionChange)="onRoleSelect($event.value)"
                            [disabled]="isSearchComplete">
                            <mat-select-trigger>
                                {{ searchForm.get('newRoleId')?.value }}
                            </mat-select-trigger>
                            <mat-option>
                                <ngx-mat-select-search [formControl]="newRoleIdctrl" placeholderLabel="Search..."
                                    noEntriesFoundLabel="No results found">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option disabled>
                                <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
                                    <span>Loading sessions...</span>
                                </div>
                            </mat-option>
                            <mat-option *ngFor="let role of filteredRoles | async" [value]="role.id">
                                {{role.id}}-{{ role.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="form-item">
                    <mat-label>Role Name</mat-label>
                    <mat-form-field class="w-full" appearance="outline">
                        <input matInput type="text" formControlName="roleName" placeholder="Enter Role Name"
                            class="h-6 text-sm" />
                    </mat-form-field>
                </div>
                <div class="form-actions">
                    <button type="reset" mat-stroked-button color="primary" [disabled]="isLoading"
                        (click)="handleReset()">Reset</button>
                    <button type="submit" mat-flat-button color="primary"
                        [disabled]="searchForm.invalid || isLoading">Search</button>

                </div>
            </div>
        </form>


        <div class="glass-card mapping-card slide-up-animation" *ngIf="showMappingTree">
            <!-- Loading Overlay for Backend Calls -->
            <div class="loading-overlay" *ngIf="isLoading">
                <mat-spinner diameter="40"></mat-spinner>
            </div>

            <div class="section-container">
                <div class="section-header">
                    <h3 class="heading">Menu Access Mapping</h3>

                    <div class="action-toolbar">
                        <button mat-button color="primary" [disabled]="isLoading || !hasChanges()"
                            (click)="confirmSave()">
                            <mat-icon>save</mat-icon> Save
                        </button>

                        <button mat-button color="primary" [disabled]="isLoading" (click)="openAddDialog()">
                            <mat-icon>add</mat-icon> Add
                        </button>
                    </div>
                </div>
            </div>

            <div class="tree-container">
                <!-- Custom Tree Table Header -->
                <div class="tree-table-header">
                    <div class="col-name" style="padding-left: 24px;">Menu Name</div>
                    <div class="col-access">
                        View Access
                    </div>
                </div>

                <div class="tree-content" *ngIf="dataSource.data.length > 0; else noData">
                    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="custom-tree">
                        <!-- Leaf node -->
                        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding class="tree-table-row leaf-node">
                            <div class="node-content">
                                <button mat-icon-button disabled class="invisible-spacer"></button>
                                <div class="node-icon-wrapper file-icon">
                                    <mat-icon>description</mat-icon>
                                </div>
                                <span class="node-name">{{node.original.menuName}}</span>
                            </div>
                            <div class="node-action">
                                <mat-checkbox *ngIf="node.level > 0" [(ngModel)]="node.original.viewAccess"
                                    color="primary"></mat-checkbox>
                            </div>
                        </mat-tree-node>

                        <!-- Expandable node -->
                        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding
                            class="tree-table-row folder-node">
                            <div class="node-content">
                                <!-- Lazy loading toggle button integration -->
                                <button mat-icon-button (click)="toggleNode(node)" class="toggle-btn"
                                    [attr.aria-label]="'Toggle ' + node.original.menuName">
                                    <mat-spinner *ngIf="node.isLoading" diameter="18"
                                        class="loading-spinner"></mat-spinner>
                                    <mat-icon *ngIf="!node.isLoading" class="mat-icon-rtl-mirror toggle-icon">
                                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                    </mat-icon>
                                </button>
                                <div class="node-icon-wrapper folder-icon"
                                    [class.expanded]="treeControl.isExpanded(node)">
                                    <mat-icon>{{treeControl.isExpanded(node) ? 'folder_open' : 'folder'}}</mat-icon>
                                </div>
                                <span class="node-name folder-name">{{node.original.menuName}}</span>
                            </div>
                            <div class="node-action">
                                <mat-checkbox *ngIf="node.level > 0" [(ngModel)]="node.original.viewAccess"
                                    (change)="onParentCheckboxChange(node, $event.checked)" color="primary">
                                </mat-checkbox>
                            </div>
                        </mat-tree-node>
                    </mat-tree>
                </div>

                <ng-template #noData>
                    <div class="empty-mapping" *ngIf="!isLoading">
                        <div class="empty-icon-wrapper">
                            <mat-icon>account_tree</mat-icon>
                        </div>
                        <h3>No Menus Found</h3>
                        <p>There are no menus mapped to this role yet. Click 'Add Menu' to get started.</p>
                        <button mat-stroked-button color="primary" (click)="openAddDialog()" style="margin-top: 16px;">
                            <mat-icon>add</mat-icon> Assign First Menu
                        </button>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>